<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Social Accounts</div>
               <button type="submit" v-on:click.prevent="AddAccounts" class="btn btn-primary waves-effect pull-right">Add Account</button>
            </div>

            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="listsocialaccount"
                        mode="remote"
                        title="List of Social Accounts"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: false,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <!--router-link title='Edit Profile' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'TalentProfile',params:{id:props.row.user.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link-->
                                    <!--router-link title='View Profile' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'TalentProfile',params:{id:props.row.id, from:''}}"><i class="fa fa-eye" aria-hidden="true"></i></router-link-->
                                    <i title='View Social Media Account' class="fa fa-eye btn edit-btn-vvg waves-effect" aria-hidden="true" v-on:click.prevent="viewAccount(props.row.id)"></i>
                                    <a title='Delete Social Media Account' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="deleteSingleUser(props.row.id)">
                                      <i class="fa fa-trash" aria-hidden="true"></i>
                                    </a>
                                </div>

                                <div v-if="props.column.field == 'social_media_type'">
                                  {{ capitalizeFirstLetter(props.row.social_media_type) }}
                                </div>

                                <div v-else-if="props.column.field == 'updated_by'">
                                  {{ capitalizeFirstLetter(props.row.updated_by) }}
                                </div>

                                <div v-else-if="props.column.field == 'created_by'">
                                  {{ capitalizeFirstLetter(props.row.created_by) }}
                                </div>

                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                        <!--div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button data-toggle="modal" id="changeRoleModel" title='Change role' class="btn btn-primary" data-target="#changeRole" >Change Role</button-->
                            <!--<button data-toggle="modal" id="changeLocationModel" title='Change location' class="btn btn-primary" data-target="#changeLocation" >Change Location</button>-->
                            <!--button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="changeSelectedUserDetails('deleteMultipleUsres')">Delete Users({{selectedRows}})</button>
                        </div-->

                    </vue-good-table>

                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>
<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
export default {
    name: 'SocialAccounts',
    components: {
        'app-backend-footer': BackendFooter,
    },
    mixins: [SessioMixin],
    data() {
      return {

          columns: [

            {
                  label: 'Social Media',
                  field: 'social_media_type',
                  filterable: true,
                  filterOptions: {
                      enabled: true, // enable filter for this column
                      placeholder: "Social Media", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      filterDropdownItems: [], // dropdown (with selected values) instead of text input
                      filterFn: this.onColumnFilter, //custom filter function that
                      trigger: "enter" //only trigger on enter not on keyup
                  }
              },
              {
                  label: 'Company Name',
                  field: 'company_name',
                  filterable: true,
                  filterOptions: {
                      enabled: true, // enable filter for this column
                      placeholder: "Company Name", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      filterDropdownItems: [], // dropdown (with selected values) instead of text input
                      filterFn: this.onColumnFilter, //custom filter function that
                      trigger: "enter" //only trigger on enter not on keyup
                  }
              },
              {
                  label: 'Account User',
                  field: 'profile_name',
                  filterable: true,
                  filterOptions: {
                      enabled: true, // enable filter for this column
                      placeholder: "Account User", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      filterDropdownItems: [], // dropdown (with selected values) instead of text input
                      filterFn: this.onColumnFilter, //custom filter function that
                      trigger: "enter" //only trigger on enter not on keyup
                  }
              },
              // {
              //     label: 'Posts',
              //     field: 'post',
              //     filterable: true,
              //     filterOptions: {
              //         enabled: true, // enable filter for this column
              //         placeholder: "Post", // placeholder for filter input
              //         filterValue: '', // initial populated value for this filter
              //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
              //         filterFn: this.onColumnFilter, //custom filter function that
              //         trigger: "enter" //only trigger on enter not on keyup
              //     }
              // },
              // {
              //     label: 'Created By',
              //     field: 'created_by',
              //     filterable: true,
              //     filterOptions: {
              //         enabled: true, // enable filter for this column
              //         placeholder: "Created By", // placeholder for filter input
              //         filterValue: '', // initial populated value for this filter
              //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
              //         filterFn: this.onColumnFilter, //custom filter function that
              //         trigger: "enter" //only trigger on enter not on keyup
              //     }
              // },
              {
                  label: 'Updated By',
                  field: 'updated_by',
                  filterable: true,
                  filterOptions: {
                      enabled: true, // enable filter for this column
                      placeholder: "Updated By", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      filterDropdownItems: [], // dropdown (with selected values) instead of text input
                      filterFn: this.onColumnFilter, //custom filter function that
                      trigger: "enter" //only trigger on enter not on keyup
                  }
              },

              // {
              //     label: 'Posted_Date',
              //     field: 'posted_by',
              //     filterable: true,
              //     filterOptions: {
              //         enabled: true, // enable filter for this column
              //         placeholder: "Posted By", // placeholder for filter input
              //         filterValue: '', // initial populated value for this filter
              //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
              //         filterFn: this.onColumnFilter, //custom filter function that
              //         trigger: "enter" //only trigger on enter not on keyup
              //     }
              // },
              {
                  label: 'Actions',
                  field: 'action',
                  html: true,
                  sortable: false,
                  thClass: 'disable-sorting',
              },




          ],
          rows: [],
          totalRecords: 0,
          serverParams: {
              columnFilters: {},
              page: 1,
              perPage: 25,
              sort: {
                  field: 'id',
                  type: 'asc',
              },
          },
          recordsCounts: "",
          selectedRows: 0,
          firstLoad: 0,

      }
    },
    beforeMount: function () {
      self = this;
      self.checkLogin();
      self.getListAccount()

    },
    methods: {
        deleteSingleUser: function(id) {
          console.log(id);
          var config = {
              headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
          };
          var fields = {
              id: id
          };
          this.$swal({
                title: 'Are you sure?',
                text: 'You can\'t revert your action',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes Delete it!',
                cancelButtonText: 'No, Keep it!',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
              if (result.value) {
                  self.showLoader();
                  HTTP.post('socialmedia/connect/delete', fields, config)
                      .then(function (response) {
                          if (response.data.code == '200') {
                              self.getListAccount()
                          } else {
                            self.$swal({
                                type: 'error',
                                text: response.data.message,
                                showConfirmButton: false,
                                timer: 5000,
                            });
                          }
                          self.hideLoader();
                      })
                      .catch(function (err) {
                        if (err.response.status == 0) {
                          if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                          } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("api_token");
                              localStorage.removeItem("profile_image");
                              self.$router.push("/login");
                              //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                          }
                        }
                          self.hideLoader();
                      })
              } else {
                self.$swal('Cancelled', 'Your record(s) still intact', 'info')
              }
          });
        },
        viewAccount: function(id) {
          self.$router.push("/backend/social/account?id=" + id);
        },
        AddAccounts: function () {
              self.$router.push('/backend/social/connect/account');
          },
          getListAccount: function () {
            self.firstLoad = 1;
            var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
            if (newPage) {
                if (newPage < self.serverParams.page) {
                    self.serverParams.page = newPage;
                }
            }
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            };
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                messageData: self.message,
                sort: self.serverParams.sort,
                year: self.year
            };
            self.showLoader();
            HTTP.post('socialmedia/profile/all',fields, config)
                .then(function (response) {
                  console.log(response);
                    if (response.data.code == '200') {
                        self.rows = response.data.content.row;
                        self.totalRecords = response.data.content.totalRecords;
                    }
                    self.hideLoader();
                })
                .catch(function (err) {
                    if (err.response.status == 0) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    }
                    self.hideLoader();
                })


          },
          updateParams(newProps) {
            self.serverParams = Object.assign({}, self.serverParams, newProps);
        },
        //
        onPageChange(params) {
            self.updateParams({page: params.currentPage});
            self.getListAccount();
        },
        onPerPageChange(params) {
            if (params.currentPerPage != self.serverParams.perPage) {
                self.updateParams({perPage: params.currentPerPage});
                self.totalRecords = self.totalRecords;
                self.getListAccount();
            }
        },
        selectionChanged() {
            var self = this;
            self.selectedRows = (self.$refs['notregisterUserList'].selectedRows).length;
            /*console.log(self.selectedRows);*/
        },

        onColumnFilter(params) {
            self.updateParams(params);
            {
                field: ('first_name');
                field: ('last_name');
                field: ('dayforce_id');
                field: ('location_name');
                field: ('role_name');
                field: ('updated_by');
            }
            ;
            self.serverParams.page = 1;
            var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
            var filters = filtersPr.columnFilters;

            if (self.firstLoad == 1 || filters.first_name || filters.last_name || filters.dayforce_id || filters.location_name || filters.role_name || filters.updated_by) {
                self.getListAccount();
            }

        },

        onSortChange(params) {
            self.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
            self.getListAccount();
        },
    },

}
</script>



// WEBPACK FOOTER //
// src/components/backend/socialmedia/socialAccounts.vue